export default __webpack_public_path__ + "static/media/Psycho.74ec261a.mp3";